import React from "react";

const Redirect: React.FC = () => {

  return (
    <>
      <div className="row intro">
        <div className="large-12 columns box redirect">
          <div className="intro-copy">
            <h1>Sorry, you can no longer sign up<br />as a member using this form</h1>
            <p className="text-center">We're redirecting you to the right place.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Redirect;